<template>
  <Popup :header="header" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>
      <v-text-field v-model="antwortKopie.kommentar"></v-text-field>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';
import _ from 'lodash';

export default {
  name: 'KommentarPopup',
  components: { Popup },
  props: {
    antwort: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      header:
        this.antwort.kommentar == null
          ? 'Kommentar hinzufügen'
          : 'Kommentar bearbeiten',
    };
  },
  antwortKopie: {
    type: Object,
    default: () => {},
  },
  beforeMount() {
    this.antwortKopie = _.cloneDeep(this.antwort);
    if (this.antwortKopie.kommentar == null) {
      this.antwortKopie.kommentar = '';
    }
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('close');
    },
    acceptAndClose() {
      Object.keys(this.antwortKopie).forEach((key) => {
        this.antwort[key] = this.antwortKopie[key];
      });
      this.$emit('save', this.antwort);
      this.closePopup();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
